import http from "../http";
import api from "../../config/api";
import { MainResponse } from "../../interfaces/api/response";

const register = {
  submit: (form: FormData): Promise<MainResponse> =>
    new Promise((resolve, reject) => {
      http
        .post(api.register, form)
        .then((res) => resolve(res as MainResponse))
        .catch((e) => reject(e));
    }),
};

export default register;
